// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Dkec","footer":"ChangeClinic_footer__1wNcw"};